export default __webpack_public_path__ + "static/media/MoneyImg.6fcfbf23.svg";